<template>
	<div class="flex-grow relative h-24 md2:h-full flex-shrink-0">
		<div class="flex flex-col w-full h-full justify-start absolute top-0 left-0 overflow-hidden">
			<!-- Scroll Up Button -->
			<div v-if="!childrenFit" class="hidden md2:flex w-full justify-center items-center font-semibold cursor-pointer">
				<button
					:disabled="isAtTop"
					:class="{ 'opacity-30 disabled:cursor-auto': isAtTop }"
					class="text-center items-center font-semibold cursor-pointer transition duration-300 ease-in-out group -rotate-90 md2:rotate-0"
					@click="back"
				>
					<svg class="w-10 h-10" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
						<polygon points="50,35 75,60 72,63 50,42 28,63 25,60" class="fill-ihh-midnight-gray group-hover:fill-ihh-gray" />
					</svg>
				</button>
			</div>

			<!-- Scrollable Content -->
			<div class="flex-grow flex md2:flex-col flex-row gap-2 md2:gap-4 overflow-y-auto snap-y snap-mandatory no-scrollbar" ref="container" @scroll="calculateScroll">
				<slot>
					<div class="p-1 ease-in-out transition duration-300 snap-start" v-for="{ zoom: image } in images" :key="image">
						<!-- @mouseover="$emit('update:image', image)" -->
						<button
							@click="handleImageSelect(image)"
							:class="{ 'border-3 border-magnolia-950': selectedImage === image }"
							class="flex bg-ihh-light-lavendar rounded-xl w-14 h-14 sm:w-20 sm:h-20 md2:w-28 md2:h-28 overflow-hidden items-center justify-center p-1 md2:p-2 shadow-md cursor-pointer group"
						>
							<div class="flex items-center justify-center w-full h-full">
								<img class="max-w-full max-h-full object-center object-contain mix-blend-darken" :src="image" alt="product image" />
							</div>
						</button>
					</div>
				</slot>
			</div>

			<!-- Scroll Down Button -->
			<div v-if="!childrenFit" class="hidden md2:flex w-full justify-center items-center font-semibold cursor-pointer">
				<button
					:disabled="isAtBottom"
					:class="{ 'opacity-30 disabled:cursor-not-allowed': isAtBottom }"
					class="text-center items-center font-semibold cursor-pointer transition duration-300 ease-in-out group -rotate-90 md2:rotate-0"
					@click="next"
				>
					<svg class="w-10 h-10" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
						<polygon points="50,65 75,40 72,37 50,58 28,37 25,40" class="fill-ihh-midnight-gray group-hover:fill-ihh-gray" />
					</svg>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import Product from '../../products/product.vue'

export default {
	components: { Product },
	props: ['images', 'label', 'shopAll', 'sideButtons'],
	data() {
		return {
			atStart: true,
			atEnd: false,
			childrenFit: false,
			observer: null,
			selectedImage: this.images[0]?.zoom,
		}
	},
	mounted() {
		this.calculateScroll()
		this.watchImages()

		// Create a MutationObserver to watch for changes
		this.observer = new MutationObserver(() => {
			this.calculateScroll()
			this.watchImages()
			this.$nextTick(() => this.calculateScroll())
		})

		// Start observing the slot container for changes
		if (this.$refs.container) {
			this.observer.observe(this.$refs.container, {
				childList: true, // Detect additions or removals of child elements
				subtree: true, // Detect changes to child elements within the slot
			})
		}
	},
	beforeUnmount() {
		// Disconnect the observer when the component is unmounted to avoid memory leaks
		if (this.observer) {
			this.observer.disconnect()
		}
	},
	watch: {
		products() {
			this.$nextTick(() => this.calculateScroll())
		},
	},
	methods: {
		next() {
			this.$refs.container.scrollBy({
				top: this.$refs.container.offsetHeight,
				behavior: 'smooth',
			})
		},
		back() {
			this.$refs.container.scrollBy({
				top: -this.$refs.container.offsetHeight,
				behavior: 'smooth',
			})
		},
		calculateScroll() {
			const containerHeight = this.$refs.container.offsetHeight
			const childrenTotalHeight = this.$refs.container.scrollHeight
			const childrenFit = containerHeight >= childrenTotalHeight

			this.childrenFit = childrenFit

			if (childrenFit) {
				this.atStart = true
				this.atEnd = true
			} else {
				this.atStart = this.$refs.container.scrollTop === 0
				this.atEnd = this.$refs.container.scrollTop + containerHeight >= childrenTotalHeight
			}
		},
		handleImageSelect(image) {
			this.$emit('update:image', image)
			this.selectedImage = image
		},
		watchImages() {
			const images = this.$refs.container.querySelectorAll('img')

			// Update the total number of images
			this.totalImages = images.length

			// Attach the load event listener to each image
			images.forEach((img) => {
				if (!img.dataset.loaded) {
					img.addEventListener('load', this.calculateScroll)
					img.dataset.loaded = true // Mark as processed to avoid adding multiple listeners
				}
			})
		},
	},
}
</script>
